import styled from 'styled-components';

import { Button } from '@xing-com/button';

export const UpsellButton = styled(Button)`
  white-space: nowrap;
`;
